import { Box, Stack, Typography } from '@mui/material'
import { stepGroupSummary } from '@/features/chat/phase1/stepGroups'
import StepIcon from './StepIcon'

const TONE = { failed: 'error', running: 'running' }

export default function StepGroupRow({ group, streaming = false }) {
  const status = TONE[group.status] ?? 'done'
  const summary = stepGroupSummary(group)
  return (
    <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
      <Box sx={{ width: 14, display: 'flex', justifyContent: 'center' }}>
        <StepIcon status={status} streaming={streaming} />
      </Box>
      <Typography sx={{
        fontSize: 'var(--app-agent-font-body)',
        fontWeight: 'var(--app-font-weight-medium)',
        color: group.status === 'running'
          ? 'var(--app-text-secondary)'
          : 'var(--app-text-secondary)',
      }}>
        {group.label}
      </Typography>
      {group.count > 1 ? (
        <Typography sx={{ fontSize: 'var(--app-thought-font-size)', color: 'var(--app-text-tertiary)' }}>
          ×{group.count}
        </Typography>
      ) : null}
      {summary ? (
        <Typography sx={{
          fontSize: 'var(--app-thought-font-size)',
          whiteSpace: 'nowrap',
          color: group.counts.failed
            ? 'var(--app-status-blocked-fg)'
            : 'var(--app-text-tertiary)',
        }}>
          {summary}
        </Typography>
      ) : null}
    </Stack>
  )
}
